// Generated by Melange


function trans(intl, id) {
  const message = {
    id: id,
    defaultMessage: id
  };
  return intl.formatMessage(message);
}

function itrans(intl, id, values) {
  const message = {
    id: id,
    defaultMessage: id
  };
  return intl.formatMessage(message, values);
}

const transComponent = trans;

const itransComponent = itrans;

export {
  trans,
  itrans,
  transComponent,
  itransComponent,
}
/* No side effect */
